const specialCharacters: Record<string, string> = {
    æ: 'ae',
    Æ: 'AE',
    ø: 'o',
    Ø: 'O',
    ß: 'ss',
}

// Dynamically generate the regex pattern from the keys of the specialCharacters object
const specialCharactersRegex = new RegExp(`[${Object.keys(specialCharacters).join('')}]`, 'g')

export const normalize = (text?: string): string => {
    if (!text) return ''
    text = text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(specialCharactersRegex, char => specialCharacters[char] || char)

    return text
}
